import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class Keyword extends ValueObject {
    rawGenericServiceProviderEventKeywordId: number;
    rawGenericServiceProviderEventMappingId: number;
    keyword: string;

    constructor(rawGenericServiceProviderEventKeywordID: number = 0,rawGenericServiceProviderEventMappingID: number = 0, keyword: string = "") {
        super();
        this.rawGenericServiceProviderEventKeywordId = rawGenericServiceProviderEventKeywordID;
        this.rawGenericServiceProviderEventMappingId = rawGenericServiceProviderEventMappingID;
        this.keyword = keyword;
    }
}